module.exports = __webpack_public_path__ + "static/media/sourcesanspro-bolditalic-webfont.dae8945d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/source-sans-pro/sourcesanspro-bolditalic-webfont.woff2
// module id = 509
// module chunks = 0